import styled, { css } from 'styled-components'

import { ContainerSize } from './Container.props'

function getSize(size: ContainerSize) {
  switch (size) {
    case 'small':
      return 850
    case 'medium':
      return 1140
    case 'large':
      return 1248
  }
}

const CONTAINER_STYLE = css<{ size: ContainerSize }>`
  margin: 0 auto;
  width: 90%;
  ${({ size }) =>
    size &&
    `
		max-width: ${typeof size === 'string' ? getSize(size) : size}px;
	`}
`

export const ContainerContent = styled.div<{ size: ContainerSize }>`
  ${CONTAINER_STYLE}
`
